import { ComponentProps, JSX } from 'react';
import classNames from 'classnames';
import PulseLoader from 'react-spinners/PulseLoader';
import classes from './Loader.module.scss';

interface IProps extends Pick<ComponentProps<typeof PulseLoader>, 'size' | 'margin'> {
    className?: string;
    dataQa?: string;
}

export const Loader = (props: IProps): JSX.Element => (
    <div className={classNames(props.className, classes.loader)} data-qa={props.dataQa}>
        <PulseLoader loading color={null} size={props.size} margin={props.margin} />
    </div>
);
